import React from 'react';
import { STEP_TITLE_CLASS } from './accountSettingsClasses';

interface DeleteAccountConfirmStepProps {
  showAdvisorProNotice: boolean;
  isDeleting: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const DeleteAccountConfirmStep: React.FC<DeleteAccountConfirmStepProps> = ({
  showAdvisorProNotice,
  isDeleting,
  onCancel,
  onConfirm,
}) => (
  <div className="flex w-full flex-col gap-5" role="alertdialog" aria-labelledby="delete-account-heading">
    <div className="flex flex-col gap-3">
      <h3 id="delete-account-heading" className={STEP_TITLE_CLASS}>Delete your account?</h3>
      <p className="m-0 font-manrope text-sm leading-5 text-[#1a1a1c]">
        This permanently deletes your profile, trips, and lists. This can&apos;t be undone.
      </p>
      {showAdvisorProNotice && (
        <p className="m-0 font-manrope text-sm leading-5 text-[#76767f]">
          Your Advisor Pro subscription will be canceled.
        </p>
      )}
    </div>
    <div className="flex gap-3">
      <button
        type="button"
        onClick={onCancel}
        disabled={isDeleting}
        className="flex h-[50px] flex-1 items-center justify-center rounded-[10px] border-none bg-[#f4f4f5] px-5 font-manrope text-sm font-bold text-[#76767f] disabled:opacity-50"
      >
        Cancel
      </button>
      <button
        type="button"
        onClick={onConfirm}
        disabled={isDeleting}
        className="flex h-[50px] flex-1 items-center justify-center rounded-[10px] border-none bg-[#ff1a00] px-5 font-manrope text-sm font-bold text-white disabled:opacity-50"
      >
        {isDeleting ? 'Deleting…' : 'Delete account'}
      </button>
    </div>
  </div>
);

export default DeleteAccountConfirmStep;
